(function () {
  
    "use strict";

    Controllers.CashflowController = class CashflowController extends Controllers.BaseControllerES6 {
        // @ngInject
        constructor($scope, $injector, $q, AppStates, UsersManager, ModalService, AnalyticsService, PopupMessageService,
                    NavigationService, PendingTasksManager, ReportsManager, moment, $sce, _) {
            super($scope, $injector);

            this.__objectType = 'CashflowController';
            this.moment = moment;
            this._ = _;
            this.$q = $q;
            this.$sce = $sce;

            this.AppStates = AppStates;
            this.AnalyticsService = AnalyticsService;
            this.PopupMessageService = PopupMessageService;
            this.NavigationService = NavigationService;
            this.AnalyticsService.trackPageView(this, 'CashflowView');
            this.UsersManager = UsersManager;
            this.ModalService = ModalService;
            this.ReportsManager = ReportsManager;
            this.PendingTasksManager = PendingTasksManager;

            this.user = UsersManager.getCurrUser();
            this.cashflowData = null;
            this.loadingOutstandingPayments = false;
            this.loadingCashflowData = false;

            const eventsReportTimeFrame = 'month';
            this.summaryReportTimeframe = {
                startDate: new Date(),
                endDate: this.moment().add(1, eventsReportTimeFrame).toDate()
            };

            this.getAccounts();
            this.getCashflow();
            this.getSummaryReport();
        }

        openConnectBankAccount() {
            this.ModalService.openConnectBankAccountModal('cashflow', 'CONNECT_BANK_ACCOUNT', true, {})
                .then((resp) => {
                    this.AnalyticsService.trackSuccess(this, 'successfully added selected sub account(s)');
                    this.getAccounts();
                }).catch((error) => {
                if(error) {
                    this.AnalyticsService.trackError(this, 'failed to connect account(s)', error);
                }
            });
        }

        getAccounts() {
            return this.UsersManager.getPlaidBusinessSubAccounts(this.user)
                .then((resp) => {
                    this.AnalyticsService.trackSuccess(this, 'got sub accounts', {numOfAccounts: resp.data.length});
                    this.accounts = resp && resp.data ? resp.data : [];
                    this.getTransactions();
                }).catch((error) => {
                    this.AnalyticsService.trackError(this, 'failed to get sub accounts', error);
                    this.accounts =[];
                });
        }

        getTransactions() {
            if(this.accounts && this.accounts.length) {
                this.loadingCashflowData = true;
                this.PendingTasksManager.createPendingTask(
                    this.PendingTasksManager.pendingTasksTypes.plaidReadTransactions, {user_id: this.user._id})
                .then((resp) => {
                    this.AnalyticsService.trackSuccess(this, 'successfully got transactions for account(s)');
                    this.getCashflow();
                }).catch((error) => {
                    this.AnalyticsService.trackError(this, 'failed to get transactions for account(s)', error);
                    this.loadingCashflowData = false;
                    this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'Failed to import expenses. Please refresh the page and retry', null, 'ok');
                });
            }
        }


        getCashflow() {
            this.loadingCashflowData = true;
            this.UsersManager.getCashflow(this.user)
                .then((resp) => {
                    this.AnalyticsService.trackSuccess(this, "Got cash flow");
                    if(resp && resp.data && resp.data.raw_aggr && resp.data.raw_aggr.length) {
                        this.cashflowData = resp.data;
                    } else {
                        this.cashflowData = null;
                    }
                    this.loadingCashflowData = false;
                }).catch((error) => {
                    this.AnalyticsService.trackError(this, "failed to get cash flow", error);
                    this.loadingCashflowData = false;
                });
        }

        goToExpenses() {
            this.AnalyticsService.trackClick(this, 'go to expenses');
            this.$state.go(this.AppStates.root_core_navigation_expenses, {});
        }

        getSummaryReport() {
            this.loadingOutstandingPayments = true;
            this.ReportsManager.getReportsPayments(this.user._id, true,
                this.summaryReportTimeframe.startDate, this.summaryReportTimeframe.endDate)
                .then((resp) => {
                    this.AnalyticsService.trackSuccess(this, "got outstanding payments");
                    const eventsReportOutstandingPayments = [...resp.data.late_payments || [],
                        ...resp.data.imminent_payments || [], ...resp.data.due_payments || []];
                    this.outstandingPaymentsAmount = eventsReportOutstandingPayments.reduce((totalAmount, payment) => {
                        return totalAmount + (payment['payment_amount'] || 0);
                    }, 0);
                    this.loadingOutstandingPayments = false;
                }).catch((error) => {
                    this.loadingOutstandingPayments = false;
                    if(error) {
                        this.AnalyticsService.trackError(this, 'failed to get outstanding payments', error);
                    }
            });
        }

        showCashflow() {
            return !!this.cashflowData  && !this.loadingCashflowData && !this.loadingOutstandingPayments;
        }

        getCashflowFrag(frag) {
            switch (frag) {
                case 'balance':
                    return this.cashflowData.current_statements.savings.current;
                case 'cc-debt':
                    return this.cashflowData.current_statements.debt.current;
                case 'future-income':
                    return this.outstandingPaymentsAmount;
                case 'future-income-timeframe':
                    return this.eventsReportTimeFrame;
                case 'bank-account-names':
                    return this.cashflowData.bank_accounts_desc
                        .filter(e => e.subtype === 'checking')
                        .map(e => e.name)
                        .join(', ');
                case 'credit-cards':
                    return this.cashflowData.bank_accounts_desc
                        .filter(e => e.subtype === "credit card");

            }
        }
    };
}());
